module.exports = __webpack_public_path__ + "static/home_scopri2-a30995208a16f3c977ab415e4f71225f.jpg";